import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { axiosInt } from '../../../utils';
import { API_IDENTITY_URL } from '../../../utils';
import type { IPaginateData } from '../../../types';
import type { IOrganization } from '../../../types/organization';

export const FETCH_ORGANIZATIONS_KEY = 'fetchOrganizations';
export const fetchOrganizations = async (
  params: any
): Promise<IPaginateData<IOrganization>> => {
  const response = await axiosInt.get(`${API_IDENTITY_URL}/organizations`, {
    params,
  });
  return response.data;
};

const useFetchOrganizations = ({
  params,
  options,
}: {
  params: any;
  options?: Partial<UseQueryOptions<IPaginateData<IOrganization>>>;
}) => {
  const {
    data: organizations,
    isLoading: isLoadingOrganizations,
    error: errorFetchingOrganizations,
  } = useQuery<IPaginateData<IOrganization>>({
    queryKey: [FETCH_ORGANIZATIONS_KEY, params],
    queryFn: () => fetchOrganizations(params),
    placeholderData: prev => prev,
    ...options,
  });

  return { organizations, isLoadingOrganizations, errorFetchingOrganizations };
};

export default useFetchOrganizations;
